<template>
  <figure :style="cssVars" :class="{ 'is-no-border-radius': isNoBorderRadius }">
    <picture>
      <source v-for="(source, idx) in images.sources" :key="idx" :type="source.type" :media="source.media" :srcset="source.srcset">
      <img
        ref="image"
        :src="images.image"
        :data-src="images.image"
        v-bind="{ loading: useNativeLazy ? 'lazy' : undefined }"
        :class="[
          isLoaded ? 'loaded' : 'loading',
          { 'is-no-border-radius': isNoBorderRadius }
        ]"
        :alt="alt"
        decoding="async"
        @load="onLoad"
      >
    </picture>

    <div v-if="!isLoaded" class="placeholder-wrapper">
      <b-skeleton
        loading
        class="skeleton-aspect-ratio"
        width="100%"
        height="100%"
      />
    </div>
  </figure>
</template>

<script>
import { contentFindOption, contentFindContent } from '../../../plugins/content'
export default {
  props: {
    aspectRatio: {
      type: String,
      default: null
    },
    aspectRatioMobile: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    sizeImage: {
      type: String,
      default: 'w1000'
    },
    isNoBorderRadius: {
      type: Boolean,
      defalt: false
    }
  },
  data () {
    return {
      useNativeLazy: false,
      isLoaded: false,
      observer: null
    }
  },
  computed: {
    images () {
      const main = contentFindContent(this.value?.content, 'main')
      const mobile = contentFindContent(this.value?.content, 'mobile') || null
      const sources = []
      const mainImageSize = main?.fileData?.sizes?.[this.sizeImage]

      let image = null
      if (main?.fileData?.isSvg) {
        image = main.fileData.isSvg.url || ''
      } else if (main?.fileData?.isImage && mainImageSize) {
        image = mainImageSize
        // Main WebP source
        const webpMain = main?.fileData?.sizes?.[this.sizeImage + '-webp'] || null
        if (webpMain) {
          sources.push({ type: 'image/webp', media: '(min-width: 768px)', srcset: webpMain })
        }
      }

      if (mobile?.fileData?.isSvg?.url) {
        sources.push({ type: 'image/svg+xml', media: '(max-width: 768px)', srcset: mobile.fileData.isSvg.url })
      } else if (mobile?.fileData?.isImage && mobile?.fileData?.sizes?.[this.sizeImage]) {
        const mobileWebp = mobile.fileData?.sizes[this.sizeImage + '-webp'] || null
        const mobileStandard = mobile?.fileData?.sizes[this.sizeImage]
        if (mobileStandard) {
          sources.push(
            { type: null, media: '(max-width: 768px)', srcset: mobileStandard }
          )
        }

        if (mobileWebp) {
          sources.push(
            { type: 'image/webp', media: '(max-width: 768px)', srcset: mobileWebp }
          )
        }
      }
      return { sources, image }
    },
    alt () {
      return contentFindOption(this.value?.options, 'alt')?.value
    },
    cssVars () {
      return {
        '--aspect-ratio': this.aspectRatio,
        '--aspect-ratio-mobile': this.aspectRatioMobile
      }
    }
  },
  created () {
    const nativeLazySupported = typeof window !== 'undefined' && 'HTMLImageElement' in window && 'loading' in HTMLImageElement.prototype
    const intersectionObserverSupported = typeof window !== 'undefined' && 'IntersectionObserver' in window
    if (!nativeLazySupported && intersectionObserverSupported) {
      this.observer = new IntersectionObserver((events) => {
        const { target, isIntersecting } = events[0]
        if (isIntersecting) {
          this.observer.unobserve(target)
        }
      })
    } else {
      this.useNativeLazy = true
    }
  },
  destroyed () {
    if (this.observer && this.$refs.image) {
      this.observer.unobserve(this.$refs.image)
    }
  },
  methods: {
    onLoad () {
      this.isLoaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
figure {
  position: relative;
  max-height: 100%;
  // width: 100%;
  // height: 100%;
  // background-color: $spati-blue-light;
  aspect-ratio: var(--aspect-ratio) !important;
  overflow: hidden;
  border-radius: 20px;
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile) !important;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
    border-radius: 20px;
  }
}

.loading {
  position: absolute;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  opacity: 0;
}

.loaded {
  opacity: 1;
  transition: opacity 0.5s ease;
}

.placeholder-wrapper {
  width: 100%;
  height: 100%;
  .is-animated {
    height: 100%;
  }
}
</style>
